// extracted by mini-css-extract-plugin
module.exports = {"background":"_1WB5sbn","close":"_2usuoKb","closeContainer":"_2l_Rk60"};